/**
 * Módulo do componente Frequencia List (frequencia-list)
 */
(function(){
	angular
		.module('frequenciaListModule', []);
})();